import React, { useState, useEffect } from "react";
import { Form, Col, Row } from "react-bootstrap";
import TextInputFormik from "../../../../components/UI/TextInput/TextInputFormik";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import useRepresentante from "../hooks/useRepresentante";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import SelectInputCachedFormik from "../../../../components/UI/SelectInput/SelectInputCachedFormik";
import CheckBoxProcedimentosFormik from "../../../../components/UI/Checkbox/CheckBoxProcedimentosFormik";
import TextInputMoneyFormik from "../../../../components/UI/TextInput/TextInputMoneyFormik";
import TextInputMaskProcessoFormik from "../../../../components/UI/TextInput/TextInputMaskProcessoFormik";

const FormAtividades = ({ formik, acaoFiscal, siglaAtividade }) => {
  const { buscaRepresentante, mascararCpf } = useRepresentante({ formik, acaoFiscal });
  const [nomeCampo, setNomeCampo] = useState("Data da Ciência");
  const [nmCampoFormik, setNmCampoFormik] = useState("dataComunicado");

  useEffect(() => {
    if (siglaAtividade === "AUINCIAIES") {
      setNmCampoFormik("dataCiencia");
    } else {
      setNmCampoFormik("dataComunicado");
    }
  }, [siglaAtividade, setNmCampoFormik]);

  useEffect(() => {
    if (siglaAtividade === "I10" || siglaAtividade === "IF10" || siglaAtividade === "A10" || siglaAtividade === "P12") {
      setNomeCampo("Data Ciência AR");
    }
    if (siglaAtividade === "I8" || siglaAtividade === "IF8" || siglaAtividade === "A8" || siglaAtividade === "P10") {
      setNomeCampo("Data de Publicação");
    }
    if (
      siglaAtividade === "A13" ||
      siglaAtividade === "M1" ||
      siglaAtividade === "M4" ||
      siglaAtividade === "D4" ||
      siglaAtividade === "P6" ||
      siglaAtividade === "P15" ||
      siglaAtividade === "D1" ||
      siglaAtividade === "A4" ||
      siglaAtividade === "AUINCIAIES" ||
      siglaAtividade === "AUINCIPEAI"
    ) {
      setNomeCampo("Data da Ciência");
    }
  }, [siglaAtividade, setNomeCampo]);

  const { values, setFieldValue } = formik;

  const handleMoneyChange = (event) => {
    setFieldValue(event.target.id, event.target.value.replace(/[^0-9]/g, "") / 100);
  };

  useEffect(() => {
    if (siglaAtividade === "M5" && parseInt(values.vlIcmsParcelado, 10) === 0) {
      setFieldValue("cdProcesso", "");
    }
  }, [siglaAtividade, values.vlIcmsParcelado, setFieldValue]);

  return (
    <>
      {siglaAtividade === "IF10" && (
        <Row>
          <Form.Group as={Col} sm={12} md={3}>
            <strong>AR assinado por:</strong>
          </Form.Group>
        </Row>
      )}

      {(siglaAtividade === "I4" ||
        siglaAtividade === "IF4" ||
        siglaAtividade === "I10" ||
        siglaAtividade === "IF10" ||
        siglaAtividade === "I11" ||
        siglaAtividade === "IF11" ||
        siglaAtividade === "A4" ||
        siglaAtividade === "A10" ||
        siglaAtividade === "A11" ||
        siglaAtividade === "M1" ||
        siglaAtividade === "P6" ||
        siglaAtividade === "P12" ||
        siglaAtividade === "P13" ||
        siglaAtividade === "D1" ||
        siglaAtividade === "AUIMPRREDO" ||
        siglaAtividade === "AUINCIAIES" ||
        siglaAtividade === "AUTEREREES" ||
        siglaAtividade === "AUTEREAIES" ||
        siglaAtividade === "AUINCIPEAI" ||
        siglaAtividade === "AUPRTERECO") && (
        <>
          <Row>
            <Form.Group as={Col} sm={12} md={3}>
              <Form.Label>CPF Representante Legal</Form.Label>
              <TextInputFormik
                formik={formik}
                field="cpfRepresentante"
                maxLength="14"
                type="text"
                evento={buscaRepresentante}
              />
            </Form.Group>
          </Row>
          <br />
        </>
      )}
      {(siglaAtividade === "I4" ||
        siglaAtividade === "IF4" ||
        siglaAtividade === "I10" ||
        siglaAtividade === "IF10" ||
        siglaAtividade === "I11" ||
        siglaAtividade === "IF11" ||
        siglaAtividade === "A4" ||
        siglaAtividade === "A10" ||
        siglaAtividade === "A11" ||
        siglaAtividade === "M1" ||
        siglaAtividade === "P6" ||
        siglaAtividade === "P12" ||
        siglaAtividade === "P13" ||
        siglaAtividade === "D1" ||
        siglaAtividade === "AUIMPRREDO" ||
        siglaAtividade === "AUINCIAIES" ||
        siglaAtividade === "AUTEREREES" ||
        siglaAtividade === "AUTEREAIES" ||
        siglaAtividade === "AUINCIPEAI" ||
        siglaAtividade === "AUPRTERECO") && (
        <>
          <Row>
            <Form.Group as={Col} sm={12} md={6}>
              <Form.Label>Nome Representante Legal</Form.Label>
              <TextInputFormik
                formik={formik}
                field="nomeRepresentante"
                type="text"
                disabled={formik.values.isHabilitado}
              />
            </Form.Group>
          </Row>
          <br />
        </>
      )}
      {(siglaAtividade === "I4" ||
        siglaAtividade === "IF4" ||
        siglaAtividade === "I10" ||
        siglaAtividade === "IF10" ||
        siglaAtividade === "I11" ||
        siglaAtividade === "IF11" ||
        siglaAtividade === "A4" ||
        siglaAtividade === "A10" ||
        siglaAtividade === "A11" ||
        siglaAtividade === "M1" ||
        siglaAtividade === "P6" ||
        siglaAtividade === "P12" ||
        siglaAtividade === "P13" ||
        siglaAtividade === "D1" ||
        siglaAtividade === "AUIMPRREDO" ||
        siglaAtividade === "AUINCIAIES" ||
        siglaAtividade === "AUTEREREES" ||
        siglaAtividade === "AUTEREAIES" ||
        siglaAtividade === "AUINCIPEAI" ||
        siglaAtividade === "AUPRTERECO") && (
        <>
          <Row>
            <Form.Group as={Col} sm={12} md={6}>
              <Form.Label>Cargo Representante Legal</Form.Label>
              <TextInputFormik formik={formik} field="cargoRepresentante" type="text" />
            </Form.Group>
          </Row>
          <br />
        </>
      )}
      {siglaAtividade === "AUPRTERECO" && (
        <Row>
          <Form.Group as={Col} sm={12} md={7}>
            <Form.Label>Endereço Representante Legal</Form.Label>
            <TextInputFormik formik={formik} field="enderecoRepresentante" type="text" />
          </Form.Group>
        </Row>
      )}

      {(siglaAtividade === "I8" || siglaAtividade === "IF8" || siglaAtividade === "A8" || siglaAtividade === "P10") && (
        <>
          <Row>
            <Form.Group as={Col} sm={12} md={3}>
              <Form.Label>Nº do Diário Oficial</Form.Label>
              <TextInputFormik formik={formik} field="nuPaginaEdital" type="text" />
            </Form.Group>
          </Row>
          <br />
        </>
      )}
      {(siglaAtividade === "I4" ||
        siglaAtividade === "IF4" ||
        siglaAtividade === "I10" ||
        siglaAtividade === "IF10" ||
        siglaAtividade === "I8" ||
        siglaAtividade === "IF8" ||
        siglaAtividade === "I13" ||
        siglaAtividade === "IF13" ||
        siglaAtividade === "A8" ||
        siglaAtividade === "A10" ||
        siglaAtividade === "A13" ||
        siglaAtividade === "M1" ||
        siglaAtividade === "M4" ||
        siglaAtividade === "D4" ||
        siglaAtividade === "P6" ||
        siglaAtividade === "P10" ||
        siglaAtividade === "P12" ||
        siglaAtividade === "P15" ||
        siglaAtividade === "D1" ||
        siglaAtividade === "A4" ||
        siglaAtividade === "AUINCIAIES" ||
        siglaAtividade === "AUINCIPEAI") && (
        <>
          <Row>
            <Form.Group as={Col} sm={12} md={3}>
              <Form.Label>{nomeCampo}</Form.Label>
              <DateTimeInputFormik formik={formik} field={nmCampoFormik} />
            </Form.Group>
          </Row>
          <br />
        </>
      )}

      {(siglaAtividade === "I9" || siglaAtividade === "IF9" || siglaAtividade === "A9" || siglaAtividade === "P11") && (
        <>
          <Row>
            <Form.Group as={Col} sm={12} md={3}>
              <Form.Label>Código de Rastreio</Form.Label>
              <TextInputFormik formik={formik} field="codigoRastreio" type="text" />
            </Form.Group>
          </Row>
          <br />
        </>
      )}

      {siglaAtividade === "M6" && (
        <Row>
          <Form.Group as={Col} sm={12} md={6}>
            <Form.Label>Monitoramento covertido em:</Form.Label>
            <SelectInputCachedFormik
              formik={formik}
              field="sequencialTipoAcaoFiscalNovo"
              tipoItem="tipo-acao-fiscal-m6"
            />
          </Form.Group>
        </Row>
      )}
      {siglaAtividade === "M6" && (
        <Row>
          <Form.Group as={Col} sm={12} md={12}>
            <CheckBoxProcedimentosFormik formik={formik} field="procedimentos" />
          </Form.Group>
        </Row>
      )}

      {siglaAtividade === "AUINJUFOCO" && (
        <Row>
          <Form.Group as={Col} sm={12} md={3}>
            <Form.Label>Justificativa</Form.Label>
            <TextInputFormik formik={formik} field="txJustificativa" type="text" rows="4" />
          </Form.Group>
        </Row>
      )}

      {siglaAtividade !== "AI2" &&
        siglaAtividade !== "AUINCIPEAI" &&
        siglaAtividade !== "IF1" &&
        siglaAtividade !== "DIRCONREAI" &&
        siglaAtividade !== "PATANAPROC" &&
        siglaAtividade !== "I1" &&
        siglaAtividade !== "D0" &&
        siglaAtividade !== "AUGEIMTENC" &&
        siglaAtividade !== "AUINFAALDO" &&
        siglaAtividade !== "AUIMPRREDO" &&
        siglaAtividade !== "AUINCONAEN" &&
        siglaAtividade !== "AULATERARB" && (
          <>
            <br />
            <Row>
              <Form.Group as={Col} sm={12} md={12}>
                {siglaAtividade === "DEDIJUSORE" && <Form.Label>Justificativa:</Form.Label>}
                {(siglaAtividade === "R1" ||
                  siglaAtividade === "AUGEIMDODE" ||
                  siglaAtividade === "M5" ||
                  siglaAtividade === "AUDJUCALAI" ||
                  siglaAtividade === "DIRDISREAI" ||
                  siglaAtividade === "AUPRTERECO") && <Form.Label>Descrição:</Form.Label>}
                {siglaAtividade === "AUAPDOREAF" && <Form.Label>Resultados Alcançados:</Form.Label>}
                {siglaAtividade === "M0" && <Form.Label>Documentos ou Informações a solicitar:</Form.Label>}
                <HtmlEditor formik={formik} field="txDescricao" rows="4" />
              </Form.Group>
            </Row>
          </>
        )}

      {siglaAtividade === "M5" && (
        <>
          <hr className="my-4" />
          <h6 className="font-weight-bold text-primary mb-3">Valores do Monitoramento</h6>
          <Row>
            <Form.Group as={Col} sm={12} md={3}>
              <Form.Label>ICMS Devido</Form.Label>
              <TextInputMoneyFormik
                formik={formik}
                field="vlIcmsDevido"
                maxLength="13"
                type="number"
                onChange={handleMoneyChange}
                defaultValue="0,00"
              />
            </Form.Group>
            <Form.Group as={Col} sm={12} md={3}>
              <Form.Label>ICMS Recolhido</Form.Label>
              <TextInputMoneyFormik
                formik={formik}
                field="vlIcmsRecolhido"
                maxLength="13"
                type="number"
                onChange={handleMoneyChange}
                defaultValue="0,00"
              />
            </Form.Group>
            <Form.Group as={Col} sm={12} md={3}>
              <Form.Label>ICMS Parcelado</Form.Label>
              <TextInputMoneyFormik
                formik={formik}
                field="vlIcmsParcelado"
                maxLength="13"
                type="number"
                onChange={handleMoneyChange}
                defaultValue="0,00"
              />
            </Form.Group>
            <Form.Group as={Col} sm={12} md={3}>
              <Form.Label>ICMS Estornado</Form.Label>
              <TextInputMoneyFormik
                formik={formik}
                field="vlIcmsEstornado"
                maxLength="13"
                type="number"
                onChange={handleMoneyChange}
                defaultValue="0,00"
              />
            </Form.Group>
          </Row>
          {parseInt(formik.values.vlIcmsParcelado, 10) > 0 && (
            <Row className="mt-2">
              <Form.Group as={Col} sm={12} md={4}>
                <Form.Label>Número do Processo</Form.Label>
                <TextInputMaskProcessoFormik
                  formik={formik}
                  field="cdProcesso"
                  mask="99999999.999999/9999-99"
                  placeholder="00000000.000000/0000-00"
                />
              </Form.Group>
            </Row>
          )}
        </>
      )}
      {siglaAtividade === "AUTEREREES" && (
        <Row>
          <Form.Group as={Col} sm={12} md={3}>
            <Form.Label>Data Recusa</Form.Label>
            <DateTimeInputFormik formik={formik} field="dataRecusa" />
          </Form.Group>
        </Row>
      )}

      {siglaAtividade === "AUTEREREES" && (
        <Row>
          <Form.Group as={Col} sm={12} md={3}>
            <Form.Label>CPF Testemunha</Form.Label>
            <TextInputFormik formik={formik} field="cpfTestemunha" maxLength="14" type="text" evento={mascararCpf} />
          </Form.Group>
        </Row>
      )}

      {siglaAtividade === "AUTEREREES" && (
        <Row>
          <Form.Group as={Col} sm={12} md={6}>
            <Form.Label>Nome Testemunha</Form.Label>
            <TextInputFormik formik={formik} field="nomeTestemunha" type="text" />
          </Form.Group>
        </Row>
      )}
      {siglaAtividade === "PATANAPROC" && (
        <Row>
          <Form.Group as={Col} sm={12} md={4}>
            <Form.Label>Número do Processo SEI</Form.Label>
            <TextInputMaskProcessoFormik
              formik={formik}
              field="cdPgeProcesso"
              mask="99999999.999999/9999-99"
              placeholder="00000000.000000/0000-00"
            />
          </Form.Group>
        </Row>
      )}
    </>
  );
};

export default FormAtividades;
